import { DropdownSvg, Select } from "@crunchyroll/cx-web-components";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import Cookie from "js-cookie";

import { LANGUAGES, LANGUAGES_BY_KEY } from "../../../constants/languages";
import { LOCALE_COOKIE } from "../../../constants/localization";
import { getLanguageByBasename } from "../../../helpers/routingHelpers";
import { BASENAME } from "../../../router/constants";
import styles from "./LanguageSelect.module.scss";

const LanguageSelect = ({ className = "" }) => {
  const { pathname, search, hash } = useLocation();

  const onChange = (key) => {
    const localeBasename = LANGUAGES_BY_KEY[key].basename;

    const domain = window.location.hostname.replace(
      /^[\w-]+\.([\w-]+)\.([\w-]+)$/,
      ".$1.$2"
    );

    Cookie.set(LOCALE_COOKIE, key, { domain });

    window.location.assign(
      `${window.location.origin}${
        localeBasename && "/" + localeBasename
      }/${BASENAME}${pathname}${search}${hash}`
    );
  };

  return (
    <Select
      className={`${styles.select} ${className}`}
      align="right"
      contentPosition="top"
      mobileHeading={<FormattedMessage id="footer.language" />}
      activeValue={getLanguageByBasename().key}
      onChange={onChange}
    >
      <Select.Trigger className={styles.trigger}>
        {(optionText) => (
          <>
            <Select.TriggerIcon as={DropdownSvg} className={styles.icon} />
            <Select.TriggerTitle className={styles.text} isDisplayedOnMobile>
              {optionText}
            </Select.TriggerTitle>
          </>
        )}
      </Select.Trigger>
      <Select.Content className={styles.content}>
        {LANGUAGES.map(({ text, key }) => (
          <Select.Option
            className={styles.option}
            text={text}
            value={key}
            key={key}
          />
        ))}
      </Select.Content>
    </Select>
  );
};

export default LanguageSelect;
